/**
 * "Thinking" animation shown while the assistant is running a longer analysis (e.g. an Omni
 * query) before any text streams back. A shimmering "Thinking" word paired with a staggered
 * pulse of dots — reads as active reasoning rather than the plain typing wave.
 */
export default function ThinkingIndicator() {
  return (
    <span role="status" aria-label="Thinking" className="inline-flex items-center gap-2 py-1">
      <span className="animate-shimmer bg-[linear-gradient(90deg,#a1a1aa_0%,#a1a1aa_40%,#27272a_50%,#a1a1aa_60%,#a1a1aa_100%)] bg-[length:200%_100%] bg-clip-text text-sm font-medium text-transparent">
        Thinking
      </span>
      <span className="inline-flex items-center gap-1">
        <span className="size-1.5 animate-pulse rounded-full bg-zinc-400 [animation-delay:-0.6s]" />
        <span className="size-1.5 animate-pulse rounded-full bg-zinc-400 [animation-delay:-0.3s]" />
        <span className="size-1.5 animate-pulse rounded-full bg-zinc-400" />
      </span>
    </span>
  );
}
